import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { Loader, PageHeader, tokens } from '@hotjar/hotsauce';
import { Page } from '@hotjar/webapp/components/Page';
import { page } from '@hotjar/webapp/domains/common/tracking/segment';
import { useIdentityProviderList } from '@hotjar/webapp/domains/sso/hooks/useIdentityProviderList';
import { usePageTitle } from '@hotjar/webapp/hooks/usePageTitle';
import { useCurrentSite } from '@hotjar/site';

import { SsoRequest } from '../SsoRequest';
import { IdentityProviderList } from './components/IdentityProviderList';

const ContentWrapper = styled.div`
  margin: ${tokens.spacer.x8} auto 0;
  max-width: 740px;
  width: 100%;
`;

export const SsoSettingsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { data: currentSite } = useCurrentSite();
  const { data: identityProviders = [], isLoading } = useIdentityProviderList(
    currentSite ? currentSite.account.id : null,
  );
  usePageTitle('SSO Settings - Hotjar');

  useEffect(() => {
    // Track Page View
    page('settings.sso');
  }, []);

  return (
    <Page>
      <PageHeader title={t('common:sso.page-title')} />
      <ContentWrapper>
        {isLoading && <Loader size="l" />}
        {!isLoading && identityProviders.length ? (
          <IdentityProviderList identityProviders={identityProviders} />
        ) : (
          <SsoRequest />
        )}
      </ContentWrapper>
    </Page>
  );
};
